import { render, staticRenderFns } from "./MarketBlock.vue?vue&type=template&id=c68d0dac&scoped=true"
import script from "./MarketBlock.vue?vue&type=script&lang=js"
export * from "./MarketBlock.vue?vue&type=script&lang=js"
import style0 from "./MarketBlock.vue?vue&type=style&index=0&id=c68d0dac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c68d0dac",
  null
  
)

export default component.exports